import PanelAlert from '@/components/panel/PanelAlert';
import { lazy, Suspense } from 'react';

const Markdown = lazy(() => import('react-markdown'));

const BaseDescription = ({ description }) => (
  <Suspense fallback={<span>{description}</span>}>
    <Markdown>{description}</Markdown>
  </Suspense>
);

const ArgumentDescription = ({ description, variant }) => {
  if (!description) {
    return null;
  }

  if (!variant || variant === 'default') {
    return (
      <div className="description">
        <BaseDescription description={description} />
      </div>
    );
  }

  const convertedVariant = variant === 'warning' ? 'warn' : variant === 'danger' ? 'error' : variant;

  return (
    <PanelAlert variant={convertedVariant} className="argument-description markdown">
      <BaseDescription description={description} />
    </PanelAlert>
  );
};

export default ArgumentDescription;
